var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm.itemsData != null
        ? _c(
            "div",
            { staticClass: "data_device_map" },
            [
              _c(
                "l-map",
                {
                  staticClass: "style_map",
                  attrs: { zoom: _vm.currentZoom, center: _vm.currentCenter },
                },
                [
                  _c("l-tile-layer", {
                    attrs: { url: _vm.url, attribution: _vm.attribution },
                  }),
                  _vm._l(_vm.itemsData, function (item) {
                    return _c(
                      "l-marker",
                      {
                        key: item._id,
                        attrs: { "lat-lng": [item.latitude, item.longitude] },
                      },
                      [
                        _c("l-popup", [
                          _c("div", { staticClass: "ctn_map_market" }, [
                            _c("div", { staticClass: "ctn_market_col _icon" }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/img/electric-meter_1.svg"),
                                  alt: "",
                                },
                              }),
                              _c("span", [_vm._v(" " + _vm._s(item.idx))]),
                            ]),
                            _c("div", { staticClass: "ctn_market_col" }, [
                              _c("div", { staticClass: "copy" }, [
                                _c("div", {}, [
                                  item.profile == "post"
                                    ? _c("span", [_vm._v("Pospago")])
                                    : _c("span", [_vm._v("Prepago")]),
                                ]),
                                _c("span", [
                                  _c("b", [_vm._v("Tipo:")]),
                                  _vm._v(" " + _vm._s(item.subTypeService)),
                                ]),
                                _c("span", [
                                  _c("b", [_vm._v("NUI:")]),
                                  _vm._v(" " + _vm._s(item.nui)),
                                ]),
                                _c("span", [
                                  _c("b", [_vm._v("Dirección")]),
                                  _vm._v(" " + _vm._s(item.address)),
                                ]),
                                _c("div", {}, [
                                  item.switch == true
                                    ? _c(
                                        "span",
                                        { staticClass: "device_active" },
                                        [_vm._v("Prendido")]
                                      )
                                    : _c(
                                        "span",
                                        { staticClass: "device_inactive" },
                                        [_vm._v("Apagado")]
                                      ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    )
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card",
        { staticClass: "no-shadow" },
        [
          _c(
            "v-card-title",
            { staticClass: "ctn_search" },
            [
              _vm._v(" Dispositivos "),
              _c("v-spacer"),
              _vm.isMaster
                ? _c("v-combobox", {
                    ref: "company",
                    staticClass: "input_filter",
                    attrs: {
                      items: _vm.itemsDataCompany,
                      "search-input": _vm.searchCompany,
                      "item-value": "_id",
                      "item-text": "name",
                      placeholder: "filtrar empresa",
                      clearable: "",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.searchCompany = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.searchCompany = $event
                      },
                    },
                    model: {
                      value: _vm.company,
                      callback: function ($$v) {
                        _vm.company = $$v
                      },
                      expression: "company",
                    },
                  })
                : _vm._e(),
              _c("v-text-field", {
                attrs: {
                  "append-icon": "mdi-magnify",
                  label: "Buscar por NUI, código interno, serial.",
                  "single-line": "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              dense: "",
              headers: _vm.getHeader,
              items: _vm.itemsData,
              loading: _vm.cargando,
              "footer-props": {
                "items-per-page-options": [10, 20, 50, 100],
              },
              "items-per-page": _vm.pagination.itemsPerPage,
              "server-items-length": _vm.totalNumberOfItems,
              options: _vm.pagination,
              search: _vm.search,
              "loading-text": "Cargando información ...",
              "hide-default-header": "",
            },
            on: {
              "update:options": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `header`,
                  fn: function ({ props: { headers } }) {
                    return [
                      _c("thead", [
                        _c(
                          "tr",
                          _vm._l(headers, function (item) {
                            return _c(
                              "th",
                              {
                                key: item.value,
                                staticClass: "column",
                                class: [
                                  item.sortable != false
                                    ? "cursor-pointer"
                                    : "",
                                  _vm.columnOrder == item.value
                                    ? "black--text"
                                    : "",
                                ],
                                on: {
                                  click: function ($event) {
                                    item.sortable != false &&
                                      _vm.changeSort(item.value)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      top: "",
                                      disabled: item.tooltip == undefined,
                                      color: "primary",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: `activator`,
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "div",
                                                _vm._g(
                                                  _vm._b(
                                                    { staticClass: "d-flex" },
                                                    "div",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  item.sortable != false &&
                                                  _vm.columnOrder == item.value
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-1",
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.orderDesc
                                                                  ? "mdi-arrow-down"
                                                                  : "mdi-arrow-up"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c("div", [
                                                    _vm._v(_vm._s(item.text)),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v(_vm._s(item.tooltip))])]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.activate`,
                  fn: function ({ item }) {
                    return [
                      item.activate == 1
                        ? _c("div", { staticClass: "lb lb_activo" }, [
                            _vm._v("Activo"),
                          ])
                        : _c("div", { staticClass: "lb lb_inactivo" }, [
                            _c("span", { staticClass: "span_inactive" }, [
                              _vm._v("Inactivo"),
                            ]),
                          ]),
                    ]
                  },
                },
                {
                  key: `item.state`,
                  fn: function ({ item }) {
                    return [
                      item.state == true
                        ? _c(
                            "div",
                            [
                              _c("v-icon", { staticClass: "i-con on" }, [
                                _vm._v("mdi-checkbox-blank-circle"),
                              ]),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("v-icon", { staticClass: "i-con off" }, [
                                _vm._v("mdi-checkbox-blank-circle"),
                              ]),
                            ],
                            1
                          ),
                    ]
                  },
                },
                {
                  key: `item.switch`,
                  fn: function ({ item }) {
                    return [
                      item.switch == true
                        ? _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c("v-icon", { staticClass: "i-con on" }, [
                                _vm._v("mdi-checkbox-blank-circle"),
                              ]),
                              _c("span"),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c("v-icon", { staticClass: "i-con off" }, [
                                _vm._v("mdi-checkbox-blank-circle"),
                              ]),
                              _c("span"),
                            ],
                            1
                          ),
                    ]
                  },
                },
                {
                  key: `item.lastData`,
                  fn: function ({ item }) {
                    return [
                      _c("div", { staticClass: "ctn_lasdata" }, [
                        item.lastData != null
                          ? _c("p", { staticClass: "ctn_lasdata_date" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatDateFrom")(
                                      item.lastData.createdAt
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _c("p", { staticClass: "ctn_lasdata_item" }, [
                          item.lastData != null
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("threeDigit")(
                                        item.lastData.valUsage
                                      )
                                    ) +
                                    _vm._s(item.lastData.unitValUsage)
                                ),
                              ])
                            : _c("span", { staticClass: "none" }, [
                                _vm._v(" - "),
                              ]),
                        ]),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.lastData.valNow`,
                  fn: function ({ item }) {
                    return [
                      _c("div", { staticClass: "ctn_lasdata" }, [
                        _c("p", { staticClass: "ctn_lasdata_item" }, [
                          _c("span", { staticClass: "grey_data" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("calculateUsage")(
                                    item.lastData !== undefined
                                      ? item.lastData.valNow +
                                          item.lastData.unitValNow
                                      : "0 --",
                                    item.dataValue.val,
                                    item.dataValue.unitVal
                                  )
                                )
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.dataValue`,
                  fn: function ({ item }) {
                    return [
                      _c("div", { staticClass: "ctn_lasdata" }, [
                        _c("p", { staticClass: "ctn_lasdata_item" }, [
                          _c("span", { staticClass: "grey_data" }, [
                            _vm._v(
                              _vm._s(_vm._f("twoDigit")(item.dataValue.val)) +
                                _vm._s(item.dataValue.unitVal)
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.profile`,
                  fn: function ({ item }) {
                    return [
                      item.profile == "post"
                        ? _c("div", [_vm._v("Postpago")])
                        : _c("div", [_vm._v("Prepago")]),
                    ]
                  },
                },
                {
                  key: `item.updateAt`,
                  fn: function ({ item }) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("formatDateFrom")(item.updateAt)) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: `item.actions`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "table_menu",
                                            attrs: {
                                              color: "primary",
                                              icon: "",
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-menu-down")])],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "list_action" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "cent",
                                      attrs: {
                                        plain: "",
                                        to: _vm.getRouteName(
                                          item.typeDevice,
                                          item._id
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setClearDeviceQuery(null)
                                        },
                                      },
                                    },
                                    [_vm._v("VER")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "list_action" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { plain: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editItem(item)
                                        },
                                      },
                                    },
                                    [_c("span", [_vm._v("Editar")])]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "list_action" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "cent",
                                      attrs: { plain: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.takeItem(item)
                                        },
                                      },
                                    },
                                    [_vm._v("Lectura")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "list_action" },
                                [
                                  item.state == true
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: { plain: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.connectItem(item)
                                            },
                                          },
                                        },
                                        [_c("span", [_vm._v("Deshabilitar")])]
                                      )
                                    : _c(
                                        "v-btn",
                                        {
                                          attrs: { plain: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.connectItem(item)
                                            },
                                          },
                                        },
                                        [_c("span", [_vm._v("Habilitar")])]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c("Edit", {
        attrs: { data: _vm.itemObjct, visible: _vm.EditFlag },
        on: {
          close: function ($event) {
            _vm.EditFlag = false
          },
        },
      }),
      _c("Connect", {
        attrs: { data: _vm.itemObjct, visible: _vm.ConnectFlag },
        on: {
          close: function ($event) {
            _vm.ConnectFlag = false
          },
        },
      }),
      _c("TakeRead", {
        attrs: { data: _vm.itemObjct, visible: _vm.TakeFlag },
        on: {
          close: function ($event) {
            _vm.TakeFlag = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }